import React from "react";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "./ui/accordion";
import { faqs, OUTBOUND_URL } from "../data/characters";

const FAQ = () => {
  return (
    <section
      id="faq"
      data-testid="faq-section"
      className="bg-white py-24 sm:py-32 border-t-2 border-black"
    >
      <div className="max-w-[1100px] mx-auto px-6 sm:px-12">
        <div className="max-w-3xl">
          <span className="text-xs sm:text-sm font-bold tracking-[0.25em] uppercase font-body text-neutral-500">
            FAQ
          </span>
          <h2
            data-testid="faq-title"
            className="font-display mt-4 text-4xl sm:text-6xl font-black tracking-tighter uppercase leading-[0.95]"
          >
            Everything About <br />
            <span className="text-[#0055FF]">Character AI Chat</span>
          </h2>
        </div>

        <div className="mt-12">
          <Accordion type="single" collapsible className="w-full">
            {faqs.map((f, i) => (
              <AccordionItem
                key={f.q}
                value={`item-${i}`}
                data-testid={`faq-item-${i}`}
                className="border-b-2 border-neutral-200"
              >
                <AccordionTrigger
                  data-testid={`faq-trigger-${i}`}
                  className="font-display text-left text-xl sm:text-2xl font-black tracking-tight uppercase py-6 hover:no-underline"
                >
                  {f.q}
                </AccordionTrigger>
                <AccordionContent
                  data-testid={`faq-content-${i}`}
                  className="font-body text-base sm:text-lg text-neutral-700 leading-relaxed pb-6 max-w-3xl"
                >
                  {f.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </div>

        <div className="mt-16 border-2 border-black p-8 sm:p-12 bg-[#FFD60A]">
          <h3 className="font-display text-3xl sm:text-5xl font-black tracking-tighter uppercase">
            Still Curious? Just Go Talk to One.
          </h3>
          <p className="font-body mt-3 max-w-2xl text-base sm:text-lg">
            The fastest way to understand character AI chat is to start one.
            Pick a character, send the first message and see how quickly the
            conversation turns into a story.
          </p>
          <a
            data-testid="faq-cta-button"
            href={OUTBOUND_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="brutal-shadow mt-6 inline-flex items-center gap-3 bg-black text-white font-display font-black uppercase tracking-tight text-base sm:text-lg px-7 py-4 border-2 border-black"
          >
            Start Character AI Chat →
          </a>
        </div>
      </div>
    </section>
  );
};

export default FAQ;
